<template>
  <a-drawer v-model:visible="openVisible"
            width="50%"
            title="立即下单"
            class="design-order-model"
            :closable="false"
            :destroy-on-close="true"
            @close="closeVisit">
    <div class="design-order-content">
      <!-- <div style="display: flex;"> -->
      <div v-if="!externalBaseData.length"
           class="lable-title">选购商品：</div>
      <SelectItem v-if="!externalBaseData.length"
                  :is_custom="true"
                  :alt_image="alt_image"
                  :colors="colors"
                  :sizes="sizes"
                  :image="image"
                  :custom_price="custom_price"
                  :selected-color="selectedColor"
                  :selected-size="selectedSize"
                  @quality-change="qualityChange"
                  @color-change="colorChangeClick"
                  @size-change="sizeChangeClick"></SelectItem>
      <!-- </div> -->
      <div v-if="!externalBaseData.length"
           style="display: flex;justify-content: flex-end;">
        <a-button type="primary"
                  class="btn-confirm"
                  @click="addToCart">确定选购</a-button>
      </div>
      <!-- <a-divider style="color:#f6f6f6;margin: 10px 0;"></a-divider> -->
      <ShoppingAddress :selected-items="selectedItems"
                       :express-list="expressList"
                       :table-ref-list=tableRefList
                       :is-design="true"></ShoppingAddress>
      <div style="display: flex;justify-content:flex-start;align-items: baseline;">
        <div class="order-title">订单备注：</div>
        <a-textarea v-model:value="remarks"
                    placeholder="请输入订单备注" />
      </div>
      <div style="display: flex;justify-content:flex-start;align-items: baseline;">
        <div class="order-title">订单来源：</div>
        <a-radio-group v-model:value="order_source">
          <a-radio :value="0">内部订单</a-radio>
          <a-radio :value="1">1688</a-radio>
        </a-radio-group>
      </div>
      <div style="display: flex;justify-content:flex-start;align-items: baseline;">
        <div v-if="order_source == 1"
             class="order-title">1688订单号：</div>
        <a-input v-if="order_source == 1"
                 v-model:value="external_number"
                 placeholder="请输入1688订单号" />
      </div>
      <div style="display: flex;justify-content:flex-start;align-items: baseline;">
        <div v-if="order_source == 1"
             class="order-title">1688订单支付号：</div>
        <a-input v-if="order_source == 1"
                 v-model:value="external_trade_number"
                 placeholder="请输入1688订单支付号" />
      </div>
    </div>
    <div v-if="checkItemVisible"
         class="check-cart">
      <a-scroll-table class="scrollTable"
                      :columns="columns"
                      :data-source="selectedItems"
                      :pagination="false">
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'color'">
            <span :style="{ backgroundColor: record.color.value }"
                  class="color-box"></span>
            <span>{{ record.color.name }}</span>
          </template>
          <template v-if="column.dataIndex === 'technology'">
            <span v-for="tec in record.technology"
                  :key="tec.id"
                  style="">{{ tec.customableImageName }}:<span style="margin-right: 5px;">{{ tec.name
                  }}</span></span>
          </template>
          <template v-if="column.dataIndex === 'operation'">
            <div style="cursor: pointer;"
                 @click="deleteItem(record)">
              <delete-outlined /> 删除
            </div>
          </template>
        </template>
      </a-scroll-table>
    </div>
    <template #footer>
      <div class="footer-box">
        <div class="footer-cart">
          <div>合计<span style="color:#DE4A09;font-weight: bold;margin: 0 5px;">{{ selectedItems.length }}</span>件</div>
          <div>已选清单
            <DownOutlined v-if="!checkItemVisible"
                          style="cursor: pointer;"
                          @click="checkItemVisible = true" />
            <UpOutlined v-if="checkItemVisible"
                        style="cursor: pointer;"
                        @click="checkItemVisible = false" />
          </div>
        </div>
        <a-button type="primary"
                  class="settle-btn"
                  :disabled="selectedItems.length == 0"
                  @click="onSubmitOrder">下单</a-button>
      </div>
    </template>
  </a-drawer>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import SelectItem from "./SelectItem.vue"
import ShoppingAddress from "./ShoppingAddress.vue"
import type { TableColumnType } from "ant-design-vue"
import { AScrollTable } from "@iota-cn/ui-components"
import { useRouter } from "vue-router"
import type {
  Color,
  CustomSpu,
  SimpleSku,
  AltImage,
  CartDataSku,
  ExternalProcurementBasicParameter
} from "../../types"
import { message } from 'ant-design-vue'
import { fetchCustomSpu, getExpress, directOrder } from "../../api"
import {
  convertColor,
  convertCustomSpuToSimpleSpu,
} from "../../utils"
import BigNumber from "bignumber.js"
const props = defineProps<{
  customSpuId: string
  openDesignOrderVisible: boolean
}>()
const emit = defineEmits([
  "closeVisit"
])
const openVisible = ref<boolean>(false)
const checkItemVisible = ref<boolean>(false)
const router = useRouter()
const customSpu = ref<CustomSpu>()
const colors = ref<Color[]>([])
const sizes = ref<string[]>([])
const customSkus = ref<SimpleSku[]>([])
const selectedColor = ref<Color>()
const selectedSize = ref<string>('')
const selectedItems = ref<any[]>([])
const image = ref<any>()
const quality = ref<number>(1)
const alt_image = ref<any>()
const custom_price = ref<any>()
const externalBaseData = ref<ExternalProcurementBasicParameter[]>([])
// 备注
const remarks = ref('')
const order_source = ref(0)
const external_number = ref('')
const external_trade_number = ref('')
const columns: TableColumnType[] = [
  {
    title: "颜色",
    dataIndex: 'color',
    align: 'center',
  },
  {
    title: "尺码",
    dataIndex: 'size',
    align: 'center',
  },
  {
    title: "数量",
    dataIndex: 'quality',
    align: 'center',
  },
  {
    title: "印花",
    dataIndex: 'technology',
    align: 'center',
  },
  {
    title: "操作",
    dataIndex: 'operation',
    align: 'center',
  },
]
const expressList = ref<any[]>([])

watch(() => props.openDesignOrderVisible, () => {
  if (props.openDesignOrderVisible) {
    init()
    openVisible.value = true
  }
})
// onMounted(() => {
//   init()
// })
const init = async () => {
  const res: any = await fetchCustomSpu(props.customSpuId)
  customSpu.value = res as CustomSpu
  if (res.external_base_data) {
    externalBaseData.value = res.external_base_data
    const image_data = customSpu.value.customizedImages[0] as any
    image.value = Object.assign({
      customized_image: image_data.customized_image,
      customized_areas: image_data.customized_areas,
      spu_customable_image: image_data.spu_customable_image,
      spu_custom_width: 2000,
      spu_custom_height: 2000,
      spu_custom_areas: { dpi: 30, top: 231, left: 320, scale: 8, width: 420, height: 480, bgWidth: 1058, bgHeight: 1058 }
    })
    addToCart()
  } else {
    custom_price.value = [] as any
    res.customizedImages?.forEach((image: any) => {
      if (image.customableImage) {
        let customized_areas_scale_title = ''
        image.customableImage?.scales?.forEach((scale: any) => {
          if (scale.customized_areas_scale == image.customized_areas.customized_areas_scale) {
            customized_areas_scale_title = scale.title
          }
        })
        let dss_image_price = '0'
        if (res.references && res.references.length > 0) {
          res.references.forEach((ref: any) => {
            if (ref.product_spu_customable_image_id == image.customableImage.id && ref.type == 2) {
              dss_image_price = new BigNumber(ref.customizedImage.ref_price).plus(dss_image_price).toFixed(2)
            }
          })
        }
        custom_price.value.push({
          id: image.customableImage.id,
          name: image.customableImage.name,
          price: image.customableImage.price,
          discount_amount_scale: image.customized_areas.discount_amount_scale,
          customized_areas_scale: image.customized_areas.customized_areas_scale,
          customized_areas_scale_title,
          technology: image.customableImage.technologies?.length > 0 ? image.customableImage.technologies[0] : {
            id: 0,
            name: '热转印'
          },
          dss_image_price,
          technologies: image.customableImage.technologies
        })
      }
    })
    customSpu.value?.customSkus?.forEach((customSku) => {
      if (customSku && customSku.sku && customSku.sku.attrs) {
        const color = customSku.sku.attrs.find((a) => {
          return a.attribute.key === "color"
        })
        customSku.color = convertColor(color?.value || color?.object_value)
      }
    })
    const {
      colors: cs,
      sizes: ss,
      customSkus: ks
    } = convertCustomSpuToSimpleSpu(customSpu.value)
    colors.value = cs
    sizes.value = ss
    customSkus.value = ks
    const altImages = customSpu.value.customizedImages[0].customableImage.altImages
    alt_image.value = altColorSelect(altImages)
    const image_data = customSpu.value.customizedImages[0]
    image.value = Object.assign({
      customized_image: image_data.customized_image,
      customized_areas: image_data.customized_areas,
      // spu_customable_image: image_data.customableImage.image,
      spu_custom_width: image_data.customableImage.width,
      spu_custom_height: image_data.customableImage.height,
      spu_custom_areas: image_data.customableImage.custom_areas
    })

    if (colors.value.length > 0) {
      colorChangeClick(colors.value[0])
    }
  }
  const expressCompanies: any = await getExpress()
  expressList.value = expressCompanies.companies
}

const closeVisit = () => {
  openVisible.value = false
  checkItemVisible.value = false
  selectedItems.value = []
  tableRefList.value = []
  emit('closeVisit', false)
}
const altColorSelect = (altImage: any) => {
  const altArr = [] as any
  altImage?.forEach((alt: AltImage) => {
    const data = {
      alt_image: alt.alt_image,
      color: alt.attrs ? alt.attrs[0].object_value : {}
    }
    altArr.push(data)
  })
  return altArr
}
const filterByColorCustomSkus = ref<CartDataSku[]>([])
const colorChangeClick = (value: Color) => {
  selectedColor.value = value
  filterByColorCustomSkus.value = filterSkusByColor(selectedColor.value, customSpu.value?.customSkus || [])
  sizes.value = filterByColorCustomSkus.value.map(sku => {
    const skuAttrs = sku.sku?.attrs as any
    return (skuAttrs.find((a: any) => {
      return a.attribute.key === 'size'
    }) || {}).value || ''
  }).filter(s => {
    return s != ''
  })
  sizeSort(sizes.value)

  if (sizes.value.length > 0) {
    const select = selectedSize.value && sizes.value.includes(selectedSize.value) ? selectedSize.value : sizes.value[0]
    sizeChangeClick(select)
  }
}
const addToCart = () => {
  if (externalBaseData.value.length) {
    selectedItems.value = externalBaseData.value.map((r: ExternalProcurementBasicParameter) =>
      Object.assign({
        id: `${customSpu.value?.spu.id}${r.color.value}${r.size}`,
        color: r.color,
        size: r.size,
        quality: r.quality,
        spu_name: customSpu.value?.spu.name,
        technology: r.technology,
        is_custom: true,
        custom_spu_id: customSpu.value!.id,
        spu_id: customSpu.value!.spu.id,
        sku_id: customSpu.value!.spu.skus[0].id || 1600,
        sku_attrs: [{ value: r.size, attribute: { key: "size", name: "尺寸" }, object_value: null }, { value: null, attribute: { key: "color", name: "颜色" }, object_value: { name: r.color.name, value: r.color.value } }, { value: "默认", attribute: { key: "weight", name: "重量(克)" }, object_value: null }]
      }, image.value))
  } else {
    const sku = JSON.parse(JSON.stringify(selectedCustomSkus.value[0]))
    const technology = [] as any
    let technologyId = ''
    custom_price.value.forEach((r: any) => {
      if (r.technology)
        technology.push({
          id: r.technology?.id,
          name: r.technology?.name,
          customableImageId: r.id,
          customableImageName: r.name
        })
      technologyId = `${technologyId}${r.technology?.id}`
    })
    let spu_customable_image = ''
    alt_image.value.forEach((r: any) => {
      if (r.color.value == sku.color.value) {
        spu_customable_image = r.alt_image
      }
    })
    const item = Object.assign({}, sku, {
      id: `${sku.id}${technologyId}`,
      quality: quality.value,
      technology,
      sku_attrs: sku.sku.attrs,
      spu_name: customSpu.value?.spu.name,
      is_custom: true,
      custom_spu_id: customSpu.value?.id,
      spu_id: customSpu.value?.spu.id,
      custom_sku_id: sku.id,
      sku_id: sku.sku.id,
      spu_customable_image
    }, image.value)
    const index = selectedItems.value.filter(s => s.id == `${sku.id}${technologyId}` && isEqual(s.technology, technology))
    if (index.length > 0) {
      selectedItems.value.forEach((r: any) => {
        if (r.id == item.id && isEqual(r.technology, technology)) {
          r.quality = r.quality + item.quality
          r.technology = technology
        }
      })
    } else {
      selectedItems.value.push(item)
    }
    if (!externalBaseData.value.length && tableRefList.value.length > 0) {
      let refIndex = 0
      for (let i = 0; i < tableRefList.value[0].length; i++) {
        if (item.id == tableRefList.value[0][i].id) {
          const refData = JSON.parse(JSON.stringify(tableRefList.value[0][i]))
          tableRefList.value[0][i].quality = item.quality + refData.quality
          refIndex++
        }
      }
      if (refIndex == 0) {
        const data = Object.assign(item, { address: tableRefList.value[0][0].address })
        tableRefList.value[0].push(data)
      }
    }
  }

}
const isEqual = (arr1: any, arr2: any) => {
  if (arr1.length !== arr2.length) {
    return false
  }
  let isEqual = false
  let index = 0
  for (let i = 0; i < arr1.length; i++) {
    for (let j = 0; j < arr2.length; j++) {
      if (arr1[i].id == arr2[j].id && arr1[i].customableImageId == arr2[j].customableImageId) {
        index++
      }
    }
  }
  index == arr1.length ? isEqual = true : isEqual = false
  return isEqual
}
const filterSkusByColor = (color: Color, arr: any[]) => {
  const r = arr.filter(k => {
    return k.color?.value === color.value
  })
  return r
}
const sizeSort = (arr: any) => {
  arr.sort((attrA: any, attrB: any) => {
    const sizeValueA = attrA.match(/\d+(\.\d+)?/g)
    const sizeValueB = attrB.match(/\d+(\.\d+)?/g)
    if (sizeValueA[0] < sizeValueB[0]) {
      return -1
    }
    if (sizeValueA[0] > sizeValueB[0]) {
      return 1
    }
    return 0
  })
  return arr
}
const selectedCustomSkus = ref<CartDataSku[]>([])
const sizeChangeClick = (value: any) => {
  selectedSize.value = value
  selectedCustomSkus.value = filterSkus('size', selectedSize.value, filterByColorCustomSkus.value)
}
const filterSkus = (key: string, value: string, arr: CartDataSku[]) => {
  return arr.filter(k => {
    const skuAttrs = k.sku?.attrs as any
    return skuAttrs.find((a: any) => {
      return a.attribute.key === key && a.value === value
    })
  })
}
const tableRefList = ref<any[]>([])
const qualityChange = (event: any) => {
  quality.value = event.quantity
}
const deepCopy = (value: any) => {
  if (!value) {
    return false
  }
  return JSON.parse(JSON.stringify(value))
}
const deleteItem = (record: any) => {
  selectedItems.value = selectedItems.value.filter(item => item.id != record.id)
  if (tableRefList.value.length > 0) {
    for (let i = 0; i < tableRefList.value.length; i++) {
      tableRefList.value[i] = tableRefList.value[i].filter((ref: any) => ref.id != record.id)
    }
    tableRefList.value = tableRefList.value.filter((ref: any) => ref.length > 0)
  }
}
const onSubmitOrder = async () => {
  const orderCart = deepCopy(tableRefList.value)
  let addressData = {} as any
  for (let i = 0; i < orderCart.length; i++) {
    for (let o = 0; o < orderCart[i].length; o++) {
      addressData = {
        receiver: orderCart[i][o].address.name,
        receiver_phone: orderCart[i][o].address.phone,
        receiver_zipcode: orderCart[i][o].address.zipcode,
        receiver_province: orderCart[i][o].address.province.name,
        receiver_city: orderCart[i][o].address.city.name,
        receiver_district: orderCart[i][o].address.district.name,
        receiver_street: orderCart[i][o].address.street.name,
        receive_address: orderCart[i][o].address.address,
        express_company_id: orderCart[i][o].express_company_id,
        express_number: orderCart[i][o].express
      }
      orderCart[i][o].address = addressData
    }
  }
  if (!addressData.receiver && !addressData.receiver_province && !addressData.express_company_id) {
    message.error("请先选择收货地址和快递")
    return
  }
  const orderData = Object.assign({
    address: orderCart,
    cart: selectedItems.value,
    remark: remarks.value,
    order_source: order_source.value,
    external_number: external_number.value,
    express_fee: 0,
    is_external: !!externalBaseData.value.length
  }, addressData)
  try {
    await directOrder(orderData).then((r: any) => {
      message.success('下单成功')
      router.push(`/console/orders/order_management/${r.order.id}`)
    })
  } catch (e) {
    console.log(444, e)
  }
}
</script>


<style lang="less" scoped>
.design-order-model {
  .ant-drawer-body {
    padding-top: 0;
  }

  .design-order-content {
    width: 100%;

    .lable-title {
      font-size: 16px;
      color: #111;
      width: 150px;
    }

    .order-title {
      color: #111;
      margin: 10px 0;
      flex: none
    }

    .flex {
      display: flex;
      align-items: center;
    }

    .lable {
      width: 60px;
    }

    .colors {
      width: 35px;
      height: 35px;
      display: flex;
      flex-wrap: wrap;
      gap: 14px;
      align-items: center;

      .color-item {
        width: 35px;
        height: 35px;
        border: 1px solid #cdcdcd;
        cursor: pointer;
      }

      .color-selected {
        border: 1px solid #111;
      }
    }

    .size-content {
      line-height: 40px;

      .size-flex {
        gap: 10px;
      }

      .size-lable {
        width: 120px;
      }
    }

    .quantity-input {
      width: 124px;
      text-align: center;

      :deep(.ant-input-group-addon) {
        padding: 0;
        width: 32px;
        height: 32px;
      }

      :deep(.ant-input) {
        height: 32px;
        padding: 0;
      }

      .input-change {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color: #F6F6F6;
      }

      .input-disabled {
        cursor: not-allowed;
      }
    }

    .btn-confirm {
      width: 100%;
      height: 40px;
      margin: 10px 0;
      background-color: #f6f6f6;
      color: #111;
      border: #f6f6f6;

      &:hover {
        border: 1px solid #111;
      }
    }


  }

  .footer-cart {
    height: 40px;
    width: 160px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // line-height: 60px;
  }

  .check-cart {
    background-color: #fff;
    width: calc(100% - 48px);
    margin: 0 24px;
    padding: 20px;
    line-height: 60px;
    position: absolute;
    bottom: 60px;
    left: 0;
    border-radius: 4px;
    box-shadow: 1px 1px 10px gray;
    // overflow: scroll;
    max-height: 400px;

    .scrollTable {

      // flex: 1;
      height: 300px;
      overflow: scroll;
    }

    .color-box {
      width: 20px;
      height: 20px;
    }
  }


  .footer-box {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;

    .settle-btn {
      width: 120px;
      height: 40px;
    }
  }
}
</style>
